import { useGetUsers } from "../services/userService";
import { RoleEnum } from "../../../api/client/types/user.types";
import { usePaginatedResource } from "../../../shared/hooks/usePaginatedResource";

export const useUsersResource = () => {
  const {
    page,
    pageSize,
    filters,
    debouncedFilters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    resetFilters,
  } = usePaginatedResource({
    initialFilters: {
      name: "",
      citizenship_number: "",
    },
  });

  const {
    data: users,
    isLoading,
    isError,
    refetch,
  } = useGetUsers({
    page,
    page_size: pageSize,
    role: RoleEnum.LIFEGUARD.toString(),
    name: debouncedFilters.name || undefined,
    citizenship_number: debouncedFilters.citizenship_number || undefined,
  });

  return {
    data: users,
    isLoading,
    isError,
    page,
    pageSize,
    filters,
    handlePageChange,
    handlePageSizeChange,
    handleFilterChange,
    resetFilters,
    refetch,
  };
};
